// extracted by mini-css-extract-plugin
module.exports = {"menuItemContainer":"styles_menuItemContainer__1Vhg0","menuItem":"styles_menuItem__GidfB","placeholder":"styles_placeholder__1Xo8s"};